import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { HubtypeUser } from 'models/hubtype-user'
import { map, withLatestFrom } from 'rxjs/operators'
import * as UserActions from 'src/app/actions/user'
import { getUsers } from 'src/app/reducers'
@Injectable({
  providedIn: 'root',
})
export class UserEffects {
  actions$ = inject(Actions)
  store = inject(Store)

  changeUserStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.changeUserStatus),
      withLatestFrom(this.store.select(getUsers)),
      map(([action, users]) => {
        const userFromUsersState = users.find(u => u.id === action.userId)

        const updatedUser = {
          ...userFromUsersState,
          status: action.status,
        } as HubtypeUser

        return UserActions.updateUser({
          user: updatedUser,
        })
      })
    )
  )
}
